module.exports = __webpack_public_path__ + "static/media/powerplatformlook.62e68fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/powerplatformlook.png
// module id = 845
// module chunks = 7